<div class="container main" id="skrollr-body">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <h1 class="about">{{ 'studentPrivacyPage.title' | translate }}</h1>

    <h3><b>{{ 'studentPrivacyPage.whoWeAre.heading' | translate }}</b></h3>
    <p [innerHTML]="'studentPrivacyPage.whoWeAre.para1' | translate"></p>

    <h3><b>{{ 'studentPrivacyPage.whatWeCollect.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.whatWeCollect.para1' | translate }}</p>
    <ul>
      <li [innerHTML]="'studentPrivacyPage.whatWeCollect.li1' | translate"></li>
      <li [innerHTML]="'studentPrivacyPage.whatWeCollect.li2' | translate"></li>
    </ul>

    <h3><b>{{ 'studentPrivacyPage.howWeCollect.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.howWeCollect.para1' | translate }}</p>
    <ul>
      <li [innerHTML]="'studentPrivacyPage.howWeCollect.li1' | translate"></li>
      <li [innerHTML]="'studentPrivacyPage.howWeCollect.li2' | translate"></li>
      <li [innerHTML]="'studentPrivacyPage.howWeCollect.li3' | translate"></li>
    </ul>

    <h3><b>{{ 'studentPrivacyPage.whatWeDo.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.whatWeDo.para1' | translate }}</p>
    <ul>
      <li>{{ 'studentPrivacyPage.whatWeDo.li1' | translate }}</li>
      <li>{{ 'studentPrivacyPage.whatWeDo.li2' | translate }}</li>
      <li>{{ 'studentPrivacyPage.whatWeDo.li3' | translate }}</li>
      <li>{{ 'studentPrivacyPage.whatWeDo.li4' | translate }}</li>
    </ul>

    <h3><b>{{ 'studentPrivacyPage.doWeShare.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.doWeShare.para1' | translate }}</p>
    <ul>
      <li>{{ 'studentPrivacyPage.doWeShare.li1' | translate }}</li>
      <li>{{ 'studentPrivacyPage.doWeShare.li2' | translate }}</li>
    </ul>
    <p>{{ 'studentPrivacyPage.doWeShare.para2' | translate }}</p>

    <h3><b>{{ 'studentPrivacyPage.howLong.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.howLong.para1' | translate }}</p>

    <h3><b>{{ 'studentPrivacyPage.aboutWebsite.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.aboutWebsite.para1' | translate }}</p>

    <h3><b>{{ 'studentPrivacyPage.canIControl.heading' | translate }}</b></h3>
    <p>{{ 'studentPrivacyPage.canIControl.para1' | translate }}</p>
    <ul>
      <li>{{ 'studentPrivacyPage.canIControl.li1' | translate }}</li>
      <li>{{ 'studentPrivacyPage.canIControl.li2' | translate }}</li>
      <li>{{ 'studentPrivacyPage.canIControl.li3' | translate }}</li>
      <li>{{ 'studentPrivacyPage.canIControl.li4' | translate }}</li>
      <li>{{ 'studentPrivacyPage.canIControl.li5' | translate }}</li>
    </ul>
    <p [innerHTML]="'studentPrivacyPage.canIControl.para2' | translate"></p>
    <p>{{ 'studentPrivacyPage.canIControl.para3' | translate }}</p>

    <h3><b>{{ 'studentPrivacyPage.contactUs.heading' | translate }}</b></h3>
    <p [innerHTML]="'studentPrivacyPage.contactUs.para1' | translate"></p>
    <p [innerHTML]="'studentPrivacyPage.contactUs.para2' | translate"></p>

    <p class="updated-date"><b>{{ 'studentPrivacyPage.updatedDate' | translate }}</b></p>
  </div>
</div>
